// app/javascript/controllers/tour_trigger_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  startTour(event) {
    event.preventDefault()

    const tourId = event.currentTarget.dataset.id

    if (tourId) {
      // Dispatch custom event that tour controllers will listen for
      document.dispatchEvent(new CustomEvent('start-tour', {
        detail: { tourId: tourId }
      }))
    }
  }
}
